/*
 * Jane Lushka v1.2: theme lists (phase 4, K16 wishlist, K17 recently viewed). Loaded on every page (defer).
 *
 * window.JLWishlist (replaces Swym):
 *   __v                       1
 *   list()                    handles, newest first
 *   has(handle)               boolean
 *   add(handle, { source, productId, itemName })     -> true when it was added
 *   remove(handle, { source })                       -> true when it was removed
 *   toggle(handle, opts)      -> the new state (true = saved)
 *   count()                   number of saved handles
 *   drop(handle)              silent remove (a product that no longer exists): no event, no announcement
 *   Storage: localStorage "jl:wishlist:v1" = JSON array of { h: handle, id: product id, t: time saved (ms) }, newest
 *   first, at most 100 (the oldest is dropped). Other tabs follow through the storage event.
 * window.JLRecent:
 *   list()                    handles, newest first
 *   record(handle)            moves the handle to the front
 *   drop(handle)              silent remove
 *   Storage: localStorage "jl:recent:v1" = JSON array of handles, newest first, at most 12.
 *
 * Hearts: button[data-jl-wishlist][data-handle][data-product-id][data-item-name][aria-pressed]
 *   (snippets/jl-wishlist-button.liquid). One delegated click listener toggles the list; every heart with the same
 *   handle follows (aria-pressed + .is-saved); the header count ([data-jl-wishlist-count], hidden at 0) and the
 *   header link's hidden label follow; "saved" / "removed" is announced in a polite region; jl:wishlist-change
 *   { action, handle, product_id, item_name, source: 'card' | 'pdp' | 'wishlist_page', count } is dispatched on
 *   document (GA4 wishlist_click). New hearts are marked by a MutationObserver (before paint) and on
 *   jl:collection-render, jl:recently-viewed-shown, shopify:section:load and pageshow.
 * The Wishlist page (section[data-jl-wishlist-page]) and Recently viewed (section[data-jl-recent]) live in
 *   assets/jl-lists-page.js, which only those two sections load (window.JLListsPage). On shopify:section:load this
 *   file hands a re-rendered section to it, and loads it first when the editor adds such a section to a page that
 *   did not have one (the section's data-jl-page-js).
 * Every storage access is wrapped: with storage blocked the hearts work in memory for the page, the count stays
 *   hidden and both lists stay empty. All visible text comes from Liquid (data attributes).
 */
(function () {
  'use strict';

  if (window.JLWishlist && window.JLWishlist.__v) return;

  var WL_KEY = 'jl:wishlist:v1';
  var WL_MAX = 100;
  var RV_KEY = 'jl:recent:v1';
  var RV_MAX = 12;

  var memWl = [];
  var memRv = [];
  var liveTimer = 0;

  /* ---------------- helpers ---------------- */

  function qs(sel, root) { return (root || document).querySelector(sel); }
  function qsa(sel, root) {
    root = root || document;
    return root.querySelectorAll ? Array.prototype.slice.call(root.querySelectorAll(sel)) : [];
  }

  function emit(name, detail) {
    var ev;
    try {
      ev = new CustomEvent(name, { detail: detail, bubbles: true });
    } catch (e) {
      ev = document.createEvent('CustomEvent');
      ev.initCustomEvent(name, true, false, detail);
    }
    document.dispatchEvent(ev);
  }

  function cleanHandle(h) {
    h = String(h == null ? '' : h).trim();
    if (!h || h.length > 255 || /[\s\/?#"'<>\\]/.test(h)) return '';
    return h;
  }

  function productIdOf(v) {
    if (v == null || v === '') return null;
    var n = Number(v);
    return isFinite(n) && n > 0 ? n : String(v);
  }

  /* ---------------- storage (always wrapped) ---------------- */

  var storageOk = (function () {
    try {
      var k = 'jl:lists-test';
      window.localStorage.setItem(k, '1');
      window.localStorage.removeItem(k);
      return true;
    } catch (e) {
      return false;
    }
  })();

  function readJson(key) {
    if (!storageOk) return null;
    try {
      var raw = window.localStorage.getItem(key);
      return raw ? JSON.parse(raw) : null;
    } catch (e) {
      return null;
    }
  }

  function writeJson(key, value) {
    if (!storageOk) return false;
    try {
      window.localStorage.setItem(key, JSON.stringify(value));
      return true;
    } catch (e) {
      return false;
    }
  }

  /* ---------------- wishlist data ---------------- */

  function wlRead() {
    var arr = storageOk ? readJson(WL_KEY) : memWl;
    if (!Array.isArray(arr)) arr = [];
    var seen = {};
    var out = [];
    for (var i = 0; i < arr.length && out.length < WL_MAX; i++) {
      var e = arr[i];
      if (!e || typeof e !== 'object') continue;
      var h = cleanHandle(e.h);
      if (!h || seen[h]) continue;
      seen[h] = true;
      out.push({ h: h, id: e.id == null ? null : e.id, t: typeof e.t === 'number' ? e.t : 0 });
    }
    return out;
  }

  function wlWrite(arr) {
    arr = arr.slice(0, WL_MAX);
    if (storageOk && writeJson(WL_KEY, arr)) return;
    /* blocked or full: keep the list in memory for this page */
    storageOk = false;
    memWl = arr;
  }

  function savedSet() {
    var set = {};
    wlRead().forEach(function (e) { set[e.h] = true; });
    return set;
  }

  function heartsFor(h, root) {
    return qsa('[data-jl-wishlist]', root).filter(function (b) { return b.getAttribute('data-handle') === h; });
  }

  function nameFor(h) {
    var hearts = heartsFor(h);
    for (var i = 0; i < hearts.length; i++) {
      var n = hearts[i].getAttribute('data-item-name');
      if (n) return n;
    }
    return '';
  }

  function idFor(h) {
    var hearts = heartsFor(h);
    for (var i = 0; i < hearts.length; i++) {
      var id = productIdOf(hearts[i].getAttribute('data-product-id'));
      if (id != null) return id;
    }
    return null;
  }

  /* ---------------- hearts, count, announcements ---------------- */

  function markHeart(btn, saved) {
    btn.classList.toggle('is-saved', !!saved);
    /* a heart on the Wishlist page is a plain remove button (no pressed state) */
    if (btn.hasAttribute('data-jl-wl-remove')) return;
    var want = saved ? 'true' : 'false';
    if (btn.getAttribute('aria-pressed') !== want) btn.setAttribute('aria-pressed', want);
  }

  function markAll(root, set) {
    set = set || savedSet();
    var list = qsa('[data-jl-wishlist]', root);
    if (root && root.matches && root.matches('[data-jl-wishlist]')) list.push(root);
    list.forEach(function (b) { markHeart(b, !!set[b.getAttribute('data-handle')]); });
  }

  function strings() {
    var el = qs('[data-jl-lists-strings]');
    if (!el) return {};
    return {
      saved: el.getAttribute('data-saved') || '',
      removed: el.getAttribute('data-removed') || '',
      countOne: el.getAttribute('data-count-one') || '',
      countOther: el.getAttribute('data-count-other') || ''
    };
  }

  function updateCounts() {
    /* storage blocked: nothing is kept, so no count is shown (K16 edge case) */
    var n = storageOk ? wlRead().length : 0;
    qsa('[data-jl-wishlist-count]').forEach(function (el) {
      if (el.textContent !== String(n)) el.textContent = String(n);
      el.hidden = n === 0;
    });
    qsa('[data-jl-wishlist-count-wrap]').forEach(function (el) { el.hidden = n === 0; });
    var s = null;
    qsa('[data-jl-wishlist-label]').forEach(function (el) {
      if (!el.hasAttribute('data-jl-base')) el.setAttribute('data-jl-base', el.textContent.trim());
      var txt = el.getAttribute('data-jl-base');
      if (n > 0) {
        s = s || strings();
        var t = n === 1 ? s.countOne : s.countOther;
        /* 99999 marks the number (also if a locale ever groups it: 99.999, 99 999) */
        if (t) txt = t.replace(/99[^0-9]?999/, String(n));
      }
      if (el.textContent !== txt) el.textContent = txt;
    });
  }

  function liveRegion() {
    var el = qs('[data-jl-lists-live]');
    if (!el && document.body) {
      el = document.createElement('p');
      el.className = 'visually-hidden';
      el.setAttribute('data-jl-lists-live', '');
      el.setAttribute('role', 'status');
      el.setAttribute('aria-live', 'polite');
      document.body.appendChild(el);
    }
    return el;
  }

  function announce(text) {
    var el = liveRegion();
    if (!el || !text) return;
    el.textContent = '';
    window.clearTimeout(liveTimer);
    liveTimer = window.setTimeout(function () { el.textContent = text; }, 60);
  }

  function afterChange(action, h, pid, name, source) {
    var set = savedSet();
    heartsFor(h).forEach(function (b) { markHeart(b, !!set[h]); });
    updateCounts();
    emit('jl:wishlist-change', {
      action: action,
      handle: h,
      product_id: pid,
      item_name: name || '',
      source: source || 'card',
      count: wlRead().length
    });
  }

  /* ---------------- window.JLWishlist ---------------- */

  function add(handle, opts) {
    opts = opts || {};
    var h = cleanHandle(handle);
    if (!h) return false;
    var arr = wlRead();
    for (var i = 0; i < arr.length; i++) if (arr[i].h === h) return false;
    var pid = productIdOf(opts.productId);
    if (pid == null) pid = idFor(h);
    arr.unshift({ h: h, id: pid, t: Date.now() });
    wlWrite(arr);
    afterChange('add', h, pid, opts.itemName || nameFor(h), opts.source);
    return true;
  }

  function remove(handle, opts) {
    opts = opts || {};
    var h = cleanHandle(handle);
    if (!h) return false;
    var arr = wlRead();
    var entry = null;
    var rest = arr.filter(function (e) {
      if (e.h === h) { entry = e; return false; }
      return true;
    });
    if (!entry) return false;
    wlWrite(rest);
    var pid = productIdOf(opts.productId);
    if (pid == null) pid = entry.id != null ? entry.id : idFor(h);
    afterChange('remove', h, pid, opts.itemName || nameFor(h), opts.source);
    return true;
  }

  function has(handle) {
    var h = cleanHandle(handle);
    if (!h) return false;
    return wlRead().some(function (e) { return e.h === h; });
  }

  function toggle(handle, opts) {
    if (has(handle)) {
      remove(handle, opts);
      return false;
    }
    add(handle, opts);
    return has(handle);
  }

  /* silent drop (a product that no longer exists): no event, no announcement */
  function wlDrop(handle) {
    var h = cleanHandle(handle);
    if (!h) return;
    var arr = wlRead();
    var rest = arr.filter(function (e) { return e.h !== h; });
    if (rest.length !== arr.length) {
      wlWrite(rest);
      updateCounts();
    }
  }

  window.JLWishlist = {
    __v: 1,
    list: function () { return wlRead().map(function (e) { return e.h; }); },
    has: has,
    add: add,
    remove: remove,
    toggle: toggle,
    count: function () { return wlRead().length; },
    drop: wlDrop
  };

  /* ---------------- window.JLRecent ---------------- */

  function rvRead() {
    var arr = storageOk ? readJson(RV_KEY) : memRv;
    if (!Array.isArray(arr)) arr = [];
    var seen = {};
    var out = [];
    for (var i = 0; i < arr.length && out.length < RV_MAX; i++) {
      var h = cleanHandle(arr[i]);
      if (!h || seen[h]) continue;
      seen[h] = true;
      out.push(h);
    }
    return out;
  }

  function rvWrite(arr) {
    arr = arr.slice(0, RV_MAX);
    if (storageOk && writeJson(RV_KEY, arr)) return;
    memRv = arr;
  }

  window.JLRecent = {
    list: rvRead,
    record: function (handle) {
      var h = cleanHandle(handle);
      if (!h) return;
      var arr = rvRead().filter(function (x) { return x !== h; });
      arr.unshift(h);
      rvWrite(arr);
    },
    drop: function (handle) {
      var h = cleanHandle(handle);
      var arr = rvRead();
      var rest = arr.filter(function (x) { return x !== h; });
      if (rest.length !== arr.length) rvWrite(rest);
    }
  };

  /* ---------------- Wishlist page and Recently viewed: assets/jl-lists-page.js ---------------- */

  var PAGE_SEL = '[data-jl-recent], [data-jl-wishlist-page]';

  function initPage(root) {
    if (window.JLListsPage) {
      window.JLListsPage.init(root);
      return;
    }
    var sec = qsa(PAGE_SEL, root)[0] || (root && root.matches && root.matches(PAGE_SEL) ? root : null);
    var src = sec && sec.getAttribute('data-jl-page-js');
    if (!src || qs('script[data-jl-lists-page]')) return;
    var s = document.createElement('script');
    s.src = src;
    s.async = true;
    s.setAttribute('data-jl-lists-page', '');
    document.head.appendChild(s);
  }

  /* ---------------- wiring ---------------- */

  function initAll(root) {
    root = root || document;
    markAll(root);
    updateCounts();
  }

  /* one delegated listener for every heart (cards, product page, lists, the Wishlist page) */
  document.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest ? e.target.closest('[data-jl-wishlist]') : null;
    if (!btn) return;
    var h = cleanHandle(btn.getAttribute('data-handle'));
    if (!h) return;
    e.preventDefault();
    var source = btn.closest('[data-jl-wishlist-page]') ? 'wishlist_page' : (btn.classList.contains('jl-wishlist--card') ? 'card' : 'pdp');
    var saved = toggle(h, { source: source, productId: btn.getAttribute('data-product-id'), itemName: btn.getAttribute('data-item-name') || '' });
    var s = strings();
    announce(saved ? s.saved : s.removed);
  });

  window.addEventListener('storage', function (e) {
    if (e.key !== WL_KEY && e.key !== null) return;
    markAll(document);
    updateCounts();
  });

  /* back/forward cache: another page may have changed the list */
  window.addEventListener('pageshow', function (e) {
    if (!e.persisted) return;
    markAll(document);
    updateCounts();
  });

  ['jl:collection-render', 'jl:recently-viewed-shown'].forEach(function (name) {
    document.addEventListener(name, function () { markAll(document); });
  });

  /* theme editor (K34): a re-rendered section comes back unmarked and uninitialised */
  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target || document;
    initAll(root);
    if (qsa(PAGE_SEL, root).length || (root.matches && root.matches(PAGE_SEL))) initPage(root);
  });

  /* new cards from any source (filters, load more, rails, the bag): mark them before they paint */
  function watch() {
    if (!window.MutationObserver || !document.body) return;
    new MutationObserver(function (records) {
      var nodes = [];
      for (var i = 0; i < records.length; i++) {
        var added = records[i].addedNodes;
        for (var j = 0; j < added.length; j++) {
          var n = added[j];
          if (n.nodeType !== 1) continue;
          if ((n.matches && n.matches('[data-jl-wishlist]')) || (n.querySelector && n.querySelector('[data-jl-wishlist]'))) nodes.push(n);
          if ((n.matches && n.matches('[data-jl-wishlist-count], [data-jl-wishlist-label]')) || (n.querySelector && n.querySelector('[data-jl-wishlist-count]'))) nodes.counts = true;
        }
      }
      if (!nodes.length && !nodes.counts) return;
      if (nodes.length) {
        var set = savedSet();
        nodes.forEach(function (n) { markAll(n, set); });
      }
      if (nodes.counts) updateCounts();
    }).observe(document.body, { childList: true, subtree: true });
  }

  function boot() {
    liveRegion();
    initAll(document);
    watch();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
